/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckSelfPublishFileRequest {
  file?: Blob | null;
  name?: string | null;
  type?: string;
  description?: string | null;
  rejection_reason?: string | null;
}
